<template>
  <!-- ヘッダー -->
  <h1 class="heading center">開錠</h1>

  <div class="content-block">
    <p class="park-title">{{ park.park_info.park_name_jp }}</p>
    <CycleInfo label="バイク番号" :value="cycle.cyc_name" />
    <CycleInfo
      label="料金"
      :value="`${park.plan_info.term1.basic.basic_period}分 ${park.plan_info.term1.basic.basic_charge}円`"
    />
  </div>

  <CycleInfoPasscode v-if="isPasscodeType" :value="reservation.passcode" />

  <div class="link-buttons">
    <div class="block">
      <DbsHowToUseLinkButton />
    </div>
  </div>

  <DbsUnlockingBottomButtons
    :is-passcode-type="isPasscodeType"
    :using-cyc-csa-name="usingCycCsaName"
    :is-reserve="true"
  />
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

export default {
  name: "TemplateDbsMyBooking",
  setup() {
    const store = useStore();
    const route = useRoute();

    const cycle = store.getters["dbs/cycle"];
    const park = store.getters["dbs/park"];
    const reservation = store.getters["dbs/reservation"];

    const isPasscodeType = cycle.csa_type == 0;
    const usingCycCsaName = route.query.cyc_csa_name;

    return {
      cycle,
      park,
      reservation,
      isPasscodeType,
      usingCycCsaName,
    };
  },
};
</script>
<style scoped>
h1.heading.center {
  margin: 60px 0 50px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.content-block {
  width: 98%;
  max-width: 500px;
  display: block;
  margin: auto;
  margin-bottom: 10vh;
}
.park-title {
  font-size: 14px;
  font-weight: bold;
  margin: 10px;
}
.link-buttons {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 160px;
}
.link-buttons .block {
  padding: 10px;
}
</style>
